var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0985 15.776V9.79693L4.20128 8.10055L2.5 7.15918V14.7208C2.5 15.3046 2.98397 15.776 3.57957 15.776H6.0985Z",
    fill: "#3D43BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7354 15.7759H17.2543C17.8517 15.7759 18.3338 15.3028 18.3338 14.7208V7.15918L16.4069 8.23741L14.7354 9.79687V15.7759Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.098 9.79673L5.83984 7.46056L6.098 5.22461L10.4162 8.38996L14.7343 5.22461L15.0231 7.33984L14.7343 9.79673L10.4162 12.9621L6.098 9.79673Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7354 5.22507V9.7972L18.3338 7.15944V5.75261C18.3338 4.44782 16.8099 3.70399 15.743 4.48651L14.7354 5.22507Z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.15947L4.15502 8.37268L6.0985 9.79723V5.2251L5.09085 4.48653C4.0221 3.70396 2.5 4.44785 2.5 5.75258V7.15941V7.15947Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.db909cba54f5a1d6ecd0b3e32bd19181.svg";
export { ForwardRef as ReactComponent };